import { render, staticRenderFns } from "./InventoryStockOpnamePrint.vue?vue&type=template&id=532bf06d"
import script from "./InventoryStockOpnamePrint.vue?vue&type=script&lang=js"
export * from "./InventoryStockOpnamePrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports